<template>
    <BaseModal
        :name="props.name"
        class="select-playlists-box include-explorer with-sticky-buttons"
    >
        <template v-slot:content>
            <template v-if="data.ready">
                <Playlists
                    :canAdd="false"
                    :canRemove="false"
                    :canEdit="false"
                    :headerId="null"
                    :disabledItems="data.disabledItems?.map(item => item.id) || []"
                    @select="onSelectItems"
                />

                <div class="buttons explorer-ignore">
                    <Button
                        class="size-l secondary"
                        :name="t('modals.confirm.cancel')"
                        @click="close"
                    />

                    <Button
                        class="size-l"
                        :name="t('pluralization.playlists.choose', {
                            count: items.length,
                            playlist: t('pluralization.playlists.playlist', items.length)
                        })"
                        :disabled="!items.length"
                        @click="select"
                    />
                </div>
            </template>
        </template>
    </BaseModal>
</template>

<script setup>
import { onMounted, reactive, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import BaseModal from '🔗/components/modals/BaseModal.vue';
import Button from '🔗/components/ui/Button.vue';
import Playlists from '@/components/blocks/Playlists.vue';

// import stores from '@/stores';

const modals = stores.modals();

const { t } = useI18n();


const data = reactive({
    ready: false,
    disabledItems: [],
    items: []
});

const props = defineProps({
    name: {
        type: String,
        default: 'select-playlists'
    }
});

const items = computed(() => {
    const ids = data.disabledItems?.map(item => item.id) || [];

    return data.items.filter(item => ids.indexOf(item.id) === -1);
});

const select = () => {
    if (!items.value?.length) {
        return;
    }

    modals.close(props.name, items.value);
};

const close = () => {
    modals.close(props.name);
}

const onSelectItems = (items) => {
    data.items = items || [];
}

onMounted(() => {
    const payload = modals.getData(props.name);

    data.disabledItems = payload?.items || [];

    data.ready = true;
});
</script>

<style lang="scss" scoped>
    @include studio.modal-buttons;
</style>

<style lang="scss">
    .select-playlists-box {
        width: 100%;
        max-width: 1200px;
        height: 100%;
        max-height: 80vh;
    }
</style>
